import {TwilioClient} from '@stripe-internal/twilio-conversations-client';

import {STPTwilioFrameInitializer} from '../../core/components/STPTwilioIframe';
import {useThreadsApp, useThreadsSelector} from '../app/hooks';

export function ThreadsLiveChatIframe() {
  const app = useThreadsApp();
  const initialized = useThreadsSelector((state) => state.initialized);

  if (!initialized) {
    return null;
  }

  return (
    <STPTwilioFrameInitializer
      config={app.config}
      chatClient={
        app.runtime === 'legacy'
          ? (app.conversations.chatClient as TwilioClient)
          : app.transports.chatClient
      }
    />
  );
}
